var map = {
	"./checkboxes-permissions.js": "./resources/js/admin/checkboxes-permissions.js",
	"./croppa.js": "./resources/js/admin/croppa.js",
	"./delete-attachment.js": "./resources/js/admin/delete-attachment.js",
	"./delete-image-in-step.js": "./resources/js/admin/delete-image-in-step.js",
	"./enable-selectize.js": "./resources/js/admin/enable-selectize.js",
	"./jquery.slug.js": "./resources/js/admin/jquery.slug.js",
	"./lang-switcher-active.js": "./resources/js/admin/lang-switcher-active.js",
	"./offcanvas-admin.js": "./resources/js/admin/offcanvas-admin.js",
	"./on-drag-file.js": "./resources/js/admin/on-drag-file.js",
	"./preview-window.js": "./resources/js/admin/preview-window.js",
	"./set-content-locale.js": "./resources/js/admin/set-content-locale.js",
	"./sidebar.js": "./resources/js/admin/sidebar.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/admin sync recursive ^(.*\\.(js$))[^.]*$/i";